import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=520fd674&scoped=true&"
import script from "./HeaderView.vue?vue&type=script&lang=js&"
export * from "./HeaderView.vue?vue&type=script&lang=js&"
import style0 from "./HeaderView.vue?vue&type=style&index=0&id=520fd674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520fd674",
  null
  
)

export default component.exports